
import React, { Component, createRef } from "react";
import { Button, Snackbar, Alert } from '@mui/material';

class CameraCanvas extends Component {
    constructor(props) {
        super(props);
        this.canvasRef = createRef();
        this.isDrawing = false;
        this.lines = []; // Stores drawn lines
        this.currentLine = null; // Temporarily stores the active drawing line
        this.isClosedShape = false; // Tracks if the current shape is closed
        this.closedShapes = [];
        this.currentShape = []; // Store lines of the current shape
        this.ignore_zones={};
        this.state = {
            selectedOption: "",
            options: {
                "Ignore Motion": '#fffa54',
                "Ignore Vehicle": "#80c4ff",
                "Ignore Bike": "#e84bff",
                "Ignore Intruder": "#52f55d",
                "Ignore All": '#f58152',
            },
            instructions : [
                "Click anywhere on the image to start drawing a shape.",
                "To finish creating a shape click on first point.",
                "Click on 'Save' button to set the selected ignore zone's shape.",
                "Click on 'Clear' button to remove the shape.",
                "Click on 'Cancel' button to go back to the ignore zone options."
            ],
            showInstructions: false,
            response_ignore_zones: { ignore_zones: {} },
            selectedShape: null,  // Stores the selected shape for deletion
        };
    }

    componentDidMount() {
        this.drawImageOnCanvas();

        // window.addEventListener("mousemove", this.handleShapeHover);
        // window.addEventListener("keydown", this.handleDeleteKeyPress);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.imageSrc !== this.props.imageSrc) {
            this.drawImageOnCanvas();
        }
        if (prevState.selectedOption !== this.state.selectedOption) {
            this.redrawCanvas();
        }

        // window.removeEventListener("mousemove", this.handleShapeHover);
        // window.removeEventListener("keydown", this.handleDeleteKeyPress);
    }

    drawImageOnCanvas = () => {
        const canvas = this.canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");

        const img = new Image();
        img.src = this.props.imageSrc;
        img.crossOrigin = "anonymous";

        img.onload = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            this.fetchIgnoreZones(); // <-- Ensure lines are drawn *after* image loads
        };

        img.onerror = () => {
            console.error("Error loading image");
        };
    };

    handleMouseDown = (event) => {
        const { offsetX, offsetY } = event.nativeEvent;
    
        // Start a completely new shape if no lines exist or the last shape is closed
        if (this.lines.length === 0 || this.isClosedShape) {
            this.currentShape = [];
            this.currentLine = { startX: offsetX, startY: offsetY, endX: offsetX, endY: offsetY };
            this.isClosedShape = false; // Reset shape closure flag
        } else {
            // Allow continuation only if the last shape was not closed
            const lastLine = this.lines[this.lines.length - 1];
            this.currentLine = {
                startX: offsetX, // Use the mouse click location, not last line endpoint
                startY: offsetY,
                endX: offsetX,
                endY: offsetY,
            };
        }
    
        this.isDrawing = true;

        if (!this.state.selectedOption) {
            this.isDrawing = false;
            this.lines = [];
            this.currentLine = null;
            alert("please select the option");
            this.drawImageOnCanvas();
            // return;
        }
    };
    
    handleMouseMove = (event) => {
        if (!this.isDrawing) return;
        const { offsetX, offsetY } = event.nativeEvent;
        this.currentLine.endX = offsetX;
        this.currentLine.endY = offsetY;
        this.redrawCanvas();
    };

    handleMouseUp = () => {
        if (!this.isDrawing) return;
        this.isDrawing = false;

        if (this.lines.length > 0) {
            const firstLine = this.lines[0];
            const distance = Math.hypot(
                this.currentLine.endX - firstLine.startX,
                this.currentLine.endY - firstLine.startY
            );
            if (distance < 10) {
                this.currentLine.endX = firstLine.startX;
                this.currentLine.endY = firstLine.startY;
                this.isClosedShape = true;
            }
        }

        if (!this.state.selectedOption) {
            alert("Please select an ignore zone option before drawing.");
            return;
        }
    
        // Initialize ignore_zones[selectedOption] if undefined
        if (!this.ignore_zones[this.state.selectedOption]) {
            this.ignore_zones[this.state.selectedOption] = [];
        }

        this.lines.push({ ...this.currentLine, color: this.state.options[this.state.selectedOption], ignore_zones: this.state.selectedOption });
        this.currentShape.push({ ...this.currentLine, color: this.state.options[this.state.selectedOption] });

        if (this.isClosedShape) {
            if (!this.ignore_zones[this.state.selectedOption]) {
                this.ignore_zones[this.state.selectedOption] = [];
            }
        
            // Store each shape separately
            this.ignore_zones[this.state.selectedOption].push([...this.currentShape]);
        
            console.log("Updated ignore zones:", this.ignore_zones);
        }
    
        // Reset state for a new shape
        this.currentLine = { startX: null, startY: null, endX: null, endY: null };
        console.log("---isClosedShape1----", this.isClosedShape);
        console.log("Captured Line Coordinates:", this.lines);
        // this.currentShape.push({ ...this.currentLine, color: this.state.options[this.state.selectedOption] });
        console.log("---isClosedShape2----", this.isClosedShape);
        this.redrawCanvas();
    };


    drawMarkers = (ctx, x, y, color) => {
        ctx.beginPath();
        ctx.arc(x, y, 5, 0, 2 * Math.PI); // Draw a small circle
        ctx.fillStyle = color;
        ctx.fill();
        ctx.closePath();
    };

    redrawCanvas = () => {
        const canvas = this.canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");

        // Clear canvas and redraw the background image
        const img = new Image();
        img.src = this.props.imageSrc;
        img.crossOrigin = "anonymous";
        img.onload = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            
            

            this.lines.forEach((line, index) => {
                //--color stroke to line based on seleced option----
                ctx.strokeStyle = line.color;
                ctx.fillStyle = line.color + "40";  // Semi-transparent fill for closed shapes
                ctx.lineWidth = 2;
                //---------------------------------------
                ctx.beginPath();
                ctx.moveTo(line.startX, line.startY);
                ctx.lineTo(line.endX, line.endY);
                ctx.stroke();
                ctx.fill();

                 // Redraw all closed shapes
                this.closedShapes.forEach(shape => {
                    ctx.beginPath();
                    ctx.moveTo(shape.lines[0].startX, shape.lines[0].startY);

                    shape.lines.forEach(line => {
                        ctx.lineTo(line.endX, line.endY);
                    });

                    ctx.closePath();
                    console.log("Drawing shape with color:", line.color);
                    let rgbaColor = this.hexToRGBA(line.color, 0.1);  // 40% opacity
                    ctx.fillStyle = rgbaColor;
                    ctx.fill();
                });          
                

                // Draw markers at start and end points
                this.drawMarkers(ctx, line.startX, line.startY, line.color); // Start point
                this.drawMarkers(ctx, line.endX, line.endY, line.color); // End point
            });

            Object.keys(this.ignore_zones).forEach(zone => {
                this.ignore_zones[zone].forEach(shape => {
                    ctx.beginPath();
                    ctx.moveTo(shape[0].startX, shape[0].startY);
            
                    shape.forEach(line => {
                        ctx.lineTo(line.endX, line.endY);
                    });
            
                    ctx.closePath();
                    ctx.fillStyle = this.hexToRGBA(shape[0].color, 0.4);
                    ctx.fill();
                    ctx.strokeStyle = shape[0].color;
                    ctx.stroke();
                });
            });
            

            // Draw the currently active line
            if (this.currentLine) {
                ctx.strokeStyle = this.state.options[this.state.selectedOption]; // Use the selected color
                ctx.lineWidth = 2;
                ctx.beginPath();
                ctx.moveTo(this.currentLine.startX, this.currentLine.startY);
                ctx.lineTo(this.currentLine.endX, this.currentLine.endY);
                ctx.stroke();

                // Draw markers for the current line
                this.drawMarkers(ctx, this.currentLine.startX, this.currentLine.startY, "green"); // Start point
                this.drawMarkers(ctx, this.currentLine.endX, this.currentLine.endY, "green"); // End point
            }
        };
    };

    // Function to Convert HEX to RGBA
    hexToRGBA(hex, opacity) {
        // Remove # if present
        hex = hex.replace(/^#/, '');

        // Parse r, g, b values from hex
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    clearCanvas = () => {
        this.lines = []; // Reset stored lines
        this.currentLine = null;
        this.closedShapes=[];
        this.currentShape = [];
        this.isClosedShape = false;
        // this.setState({selectedOption:"Ignore Vehicle"});
        this.ignore_zones={};
        this.setState({selectedOption:""});
        this.redrawCanvas(); // Redraw the image without lines
    };

    handleOptionChange = (option) => {
        // this.setState({ selectedOption: option, showInstructions: true });
        this.setState({ selectedOption: option, showInstructions: true }, () => {
            // this.fetchIgnoreZones(); // Re-fetch and redraw zones after state updates
            this.drawImageOnCanvas()
        });
    };

    handleBack = () => {

        this.setState({ selectedOption: "", showInstructions: false }, () => {
            if(this.lines != []){
            this.currentLine = null;
            this.closedShapes=[];
            this.currentShape = [];
            this.lines = [];
            this.ignore_zones={};
            setTimeout(() => {
                this.drawImageOnCanvas();
              }, 500);
            
            }
            else{
                this.drawImageOnCanvas();
            }
        });
    };


    // saveLinesToBackend = async () => { //--------------------WORKING function to save and append new shape to previous shapes.
    //     // Ensure this.lines is an array and not empty
    //     if (!Array.isArray(this.lines) || this.lines.length === 0) {
    //         console.error("No lines available to save.");
    //         return;
    //     }
    
    //     let groupedData = {};
    
    //     // Loop through this.lines safely
    //     this.lines.forEach(line => {
    //         if (!line || typeof line !== "object" || !line.ignore_zones) {
    //             console.error("Invalid line object detected:", line);
    //             return; // Skip invalid entries
    //         }
    
    //         if (!groupedData[line.ignore_zones]) {
    //             groupedData[line.ignore_zones] = [];
    //         }
    
    //         groupedData[line.ignore_zones].push({
    //             startX: line.startX,
    //             startY: line.startY,
    //             endX: line.endX,
    //             endY: line.endY,
    //             color: line.color
    //         });
    //     });
    
    //     console.log("Grouped Data:", groupedData);
    
    //     // Ensure state is initialized
    //     this.setState(prevState => {
    //         let existingData = prevState.response_ignore_zones || { lines: {} };
    
    //         // Ensure existingData.lines is defined
    //         if (!existingData.lines) {
    //             existingData.lines = {};
    //         }
    
    //         // Merge with existing data
    //         Object.keys(groupedData).forEach(key => {
    //             if (!existingData.lines[key]) {
    //                 existingData.lines[key] = [];
    //             }
    //             existingData.lines[key] = [...existingData.lines[key], ...groupedData[key]];
    //         });
    
    //         return { response_ignore_zones: { ...existingData } };
    //     }, () => {
    //         console.log("Updated ignore zones:", this.state.response_ignore_zones);
    //         alert("Ignore zone set successfully!");
    //     });
    // };
    
    saveLinesToBackend = async () => { //-----------------modified, working function to maintain separate shapes of same/diff ignore zones to avoid connecting the lines of same ig.zone/color.
        if (!this.ignore_zones || Object.keys(this.ignore_zones).length === 0) {
            console.error("No shapes available to save.");
            return;
        }

        let postData = {
            ignore_zones: { ...this.ignore_zones }  // Ensure separate shapes are maintained
        };

        console.log("Saving shapes:", postData);

        this.setState(prevState => {
            let existingData = prevState.response_ignore_zones || { ignore_zones: {} };
        
            // Ensure existingData.ignore_zones is defined
            if (!existingData.ignore_zones) {
                existingData.ignore_zones = {};
            }
        
            // Merge new shapes into existing data
            Object.keys(this.ignore_zones).forEach(zone => {
                if (!existingData.ignore_zones[zone]) {
                    existingData.ignore_zones[zone] = [];
                }
                existingData.ignore_zones[zone] = [
                    ...existingData.ignore_zones[zone], // Keep old shapes
                    ...this.ignore_zones[zone] // Append new shapes
                ];
            });
        
            return { response_ignore_zones: existingData };
        }, () => {
            console.log("Updated ignore zones:", this.state.response_ignore_zones);
            alert("Ignore zones saved successfully!");
        });
        
    };


    // fetchIgnoreZones = async() => { //TODO-----------previous working function--
    //     console.log("-------fetching ignore zone--------");
    //     const canvas = this.canvasRef.current;
    //     if (!canvas) return;
    //     const ctx = canvas.getContext("2d");

    //     // const response = {  //--------------dummy data--------------------------------
    //     //     lines: {
    //     //         "Ignore Vehicle": [
    //     //             { startX: 121, startY: 167, endX: 94, endY: 311, color: "#80c4ff" },
    //     //             { startX: 94, startY: 311, endX: 332, endY: 326, color: "#80c4ff" },
    //     //             { startX: 332, startY: 326, endX: 121, endY: 167, color: "#80c4ff" }
    //     //         ],
    //     //         "Ignore Bike" : [
    //     //             { startX: 248, startY: 196, endX: 106, endY: 344, color: "#e84bff" },
    //     //             { startX: 106, startY: 344, endX: 422, endY: 355, color: "#e84bff" },
    //     //             { startX: 422, startY: 355, endX: 418, endY: 232, color: "#e84bff" },
    //     //             { startX: 418, startY: 232, endX: 248, endY: 196, color: "#e84bff" }
    //     //         ]
    //     //     }
    //     // };

    //     const response = this.state.response_ignore_zones; // setting response as realtime postData and again fetching it to show.
    //     console.log("-------fetching ignore zone--------", this.state.response_ignore_zones);
    //     console.log("-------fetching ignore zone response--------", response);


    //     if (!response || !response.lines) return;

    //     // Check if the selected option exists in response
    //     if (this.state.selectedOption && response.lines[this.state.selectedOption]) {
    //         const lines = response.lines[this.state.selectedOption];

    //         ctx.beginPath();
    //         ctx.moveTo(lines[0].startX, lines[0].startY);

    //         lines.forEach(line => {
    //             ctx.lineTo(line.endX, line.endY);
    //         });

    //         ctx.closePath(); // Close the shape

    //         // Use first line's color for fill & stroke
    //         const fillColor = lines[0].color.replace("#", ""); // Remove # for opacity handling
    //         ctx.fillStyle = `#${fillColor}80`; // Add '80' for transparency (50% opacity)
    //         ctx.fill();

    //         ctx.strokeStyle = lines[0].color; // Border color
    //         ctx.lineWidth = 2;
    //         ctx.stroke();
    //     }
    //     else{
    //         Object.keys(response.lines).forEach(category => {
    //             const lines = response.lines[category];
    //             if (!lines || lines.length === 0) return;
    
    //             // Start drawing the shape
    //             ctx.beginPath();
    //             ctx.moveTo(lines[0].startX, lines[0].startY);
    
    //             lines.forEach(line => {
    //                 ctx.lineTo(line.endX, line.endY);
    //             });
    
    //             ctx.closePath(); // Close the shape
    
    //             // Use the first line's color for fill & stroke
    //             const fillColor = lines[0].color.replace("#", ""); // Remove # for opacity handling
    //             ctx.fillStyle = `#${fillColor}80`; // Add '80' for transparency (50% opacity)
    //             ctx.fill();
    
    //             ctx.strokeStyle = lines[0].color; // Border color
    //             ctx.lineWidth = 2;
    //             ctx.stroke();
    //         });
    //     }
    // };
   

    fetchIgnoreZones = async () => {    //New working function for seperating same ignore zones shapes. (previously shapes or same color were getting connected after fetching.)
        console.log("Fetching ignore zones...");
        const canvas = this.canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
    
        const response = this.state.response_ignore_zones;
        if (!response || !response.ignore_zones) return;

        // If an option is selected, show only that ignore zone's shapes
        let zonesToRender = this.state.selectedOption 
            ? { [this.state.selectedOption]: response.ignore_zones[this.state.selectedOption] || [] }
            : response.ignore_zones;
    
        Object.keys(zonesToRender).forEach(zone => {
            zonesToRender[zone].forEach((shape, shapeIndex) => {
                if (!shape || shape.length === 0) return;
    
                ctx.beginPath();
                ctx.moveTo(shape[0].startX, shape[0].startY);
    
                shape.forEach(line => {
                    ctx.lineTo(line.endX, line.endY);
                });
    
                ctx.closePath();
                ctx.fillStyle = this.hexToRGBA(shape[0].color, 0.4);
                ctx.fill();
                ctx.strokeStyle = shape[0].color;
                ctx.stroke();

                // Highlight selected shape by drawing markers
                if (this.state.selectedShape === shapeIndex) {
                    shape.forEach(line => {
                        this.drawMarkers(ctx, line.startX, line.startY, "red"); // Start point
                        this.drawMarkers(ctx, line.endX, line.endY, "red"); // End point
                    });
                }
            });
        });
    };

    isPointInsidePolygon = (x, y, shape) => {  //function to select shape when user clicks inside the shape.
        let inside = false;
        for (let i = 0, j = shape.length - 1; i < shape.length; j = i++) {
            let xi = shape[i].startX, yi = shape[i].startY;
            let xj = shape[j].startX, yj = shape[j].startY;
    
            let intersect = ((yi > y) !== (yj > y)) && 
                            (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }
        return inside;
    };
    
    
    
    handleCanvasClick = (event) => {
        const { offsetX, offsetY } = event.nativeEvent;
        
        if (!this.state.selectedOption || !this.state.response_ignore_zones.ignore_zones[this.state.selectedOption]) return;
    
        let foundShape = null;
        
        this.state.response_ignore_zones.ignore_zones[this.state.selectedOption]?.forEach((shape, index) => {
            if (this.isPointInsidePolygon(offsetX, offsetY, shape)) {
                foundShape = index;
            }
        });
    
        if (foundShape !== null) {
            this.setState({ selectedShape: foundShape }, () => this.fetchIgnoreZones());
        }
    };
    
    
    handleDeleteKeyPress = (event) => {
        if (event.keyCode === 46 && this.state.selectedShape !== null) { // 46 is the keyCode for 'Delete'
            this.deleteSelectedShape();
        }
    };

    // deleteSelectedShape = async () => { //----test function to delete shape with backend api integration
    //     const { selectedOption, selectedShape, response_ignore_zones } = this.state;
        
    //     if (selectedShape === null || !selectedOption) return;
    
    //     let updatedIgnoreZones = { ...response_ignore_zones };
    //     updatedIgnoreZones.ignore_zones[selectedOption].splice(selectedShape, 1);
    
    //     this.setState({ response_ignore_zones: updatedIgnoreZones, selectedShape: null }, async () => {
    //         this.fetchIgnoreZones();
    
    //         // try {
    //         //     // Call backend API to delete shape
    //         //     await fetch('/api/delete-shape', {
    //         //         method: 'POST',
    //         //         headers: { 'Content-Type': 'application/json' },
    //         //         body: JSON.stringify({ option: selectedOption, shapeIndex: selectedShape }),
    //         //     });
    //         //     alert("Shape deleted successfully!");
    //         // } catch (error) {
    //         //     console.error("Error deleting shape:", error);
    //         //     alert("Failed to delete shape.");
    //         // }
    //     });
    // };
    
    deleteSelectedShape = async () => { //test function to delete shape stored in local storage/mock server types implementation.
        const { selectedOption, selectedShape, response_ignore_zones } = this.state;
    
        if (selectedShape === null || !selectedOption) return;
    
        let updatedIgnoreZones = { ...response_ignore_zones };
        updatedIgnoreZones.ignore_zones[selectedOption].splice(selectedShape, 1);
    
        this.setState({ response_ignore_zones: updatedIgnoreZones, selectedShape: null }, () => {
            this.redrawCanvas(); // Update UI after deletion
        });
    };
    
    

    render() {
        return (
            <div style={{ padding: "16px", border: "1px solid #d1d1e8", borderRadius: "8px", backgroundColor: "#fff", height: "auto", display: "flex",gap: "150px",alignItems: "flex-start" }}>
                
                <div style={{ display: "flex", flexDirection: "column", alignItems: "left" }}>
                <canvas
                    ref={this.canvasRef}
                    width={500}
                    height={500}
                    style={{ cursor: "crosshair", zIndex: '10' }} // Updated cursor style
                    // onClick={this.handleCanvasClick}
                    onMouseDown={this.handleMouseDown}
                    onMouseMove={this.handleMouseMove}
                    onMouseUp={this.handleMouseUp}
                /><br />
                <button 
                    onClick={this.clearCanvas} 
                    style={{
                        width: "80px",
                        marginTop: "10px",
                        padding: "8px 16px",
                        backgroundColor: "#ff4d4d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "16px"
                    }}
                >
                    Clear
                </button>
                </div>

                <div style={{ display: "flex",flexDirection: "column", gap: "10px", marginBottom: "10px" }}>
                    {!this.state.showInstructions ? (
                        <>
                        <p style={{color:'#04637b', fontSize:'20px', fontWeight:'580px'}}>Click on the ignore zone you'd like to set </p>
                            {Object.keys(this.state.options).map((option) => (
                                <div 
                                    key={option} 
                                    onClick={() => this.handleOptionChange(option)} 
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        overflow: "hidden",
                                        width: "150px",
                                        backgroundColor: "#fff", // Keeps the button background always white
                                        height: "40px"
                                    }}
                                >
                                    
                                    {/* Color legend on the left */}
                                    <div 
                                        style={{
                                            width: "20px",
                                            height: "100%",
                                            backgroundColor: this.state.options[option]
                                        }}
                                    ></div>
                                                    {/* Option label */}
                                    <div 
                                        style={{
                                            flex: 1,
                                            padding: "10px",
                                            color: "#000",  // Always black text
                                            fontWeight: this.state.selectedOption === option ? "bold" : "normal", // Highlight selected option                    color: this.state.selectedOption === option ? "#fff" : "#000",
                                            textAlign: "left"
                                        }}
                                    >
                                        {option}
                                    </div>
                                </div>
                            ))}
                        </>
                         ) : (
                    /* Instructions Section */
                    <>
                    <div style={{display:'flex', justifyContent:'flex-start', gap:'15px'}}>
                        <Button 
                        onClick={this.saveLinesToBackend} 
                        id="ignoreZoneSaveButton"
                        style={{ marginTop: "10px", padding: "5px 10px", cursor: "pointer" }}
                        >
                            Save
                        </Button>
                        <Button onClick={this.handleBack} id="clearUserLogButton" style={{ marginTop: "10px", padding: "5px 10px", cursor: "pointer" }}>
                                go Back to Options
                                {/* cancel */}
                        </Button>
                    </div>
                    <div style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px", background: "#f9f9f9" }}>
                    
                        <h3>Instructions</h3>
                        <ul>
                            {this.state.instructions.map((instruction, index) => (
                            <>
                                {/* Using index as a key */}
                                <li key={index}>{instruction}</li><br/> 
                            </>
                            ))}
                        </ul>
                        
                    </div>
                    </>
                )}
                </div>
            </div>
        );
    }
}

export default CameraCanvas;


